import {Component} from "@angular/core";
import {Route} from "@angular/router";


@Component({
  selector: 'kmhd-root-page',
  templateUrl: 'root.page.html'
})
export class KmhdRootPage {

}
